import { useCreatorData } from 'root/src/client/logic/api/hooks/useCreatorData';
export const useRelatedProfiles = () => {
    var _a;
    const creatorData = useCreatorData();
    return (_a = creatorData === null || creatorData === void 0 ? void 0 : creatorData.relatedProfiles) !== null && _a !== void 0 ? _a : [];
};
